export default __webpack_public_path__ + "static/media/casual.70c46ac5.jpg";